import { eventsCol } from '../firebase'
export default {
  getEvents() {
    return eventsCol.get()
  },
  pushEvent(event) {
    return eventsCol.add(event)
  },
  updateEvent(event) {
    return eventsCol.doc(event.id).update(event)
  },
  deleteEvent(event) {
    return eventsCol.doc(event.id).delete()
  },
  getNotificationEvents() {
    const today = new Date()
    let until = new Date()
    until.setDate(until.getDate() + 3)
    return eventsCol
      .where('timestamp', '>=', today.getTime())
      .where('timestamp', '<=', until.getTime())
      .get()
  }
}
